import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { MAILIDLIST_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  suggestion: { label: "Suggestion", color: "#FDF2F8", textColor: "#9D174D" },
};

function MailIdList() {
  const [mailId, setMailId] = useState([]);
  const [mailIdFilled, setMailIdFilled] = useState(["bob@gmail.com"]);
  const [mailIdDisabled, setMailIdDisabled] = useState([]);
  const [mailIdFilledDisabled, setMailIdFilledDisabled] = useState([
    "bob@gmail.com",
  ]);

  return (
    <div>
      <div className="grid grid-cols-4 gap-3 my-5 mb-30">
        <div>
          <FormFieldSet value={mailId} onChange={setMailId} type="toMailIds" />
        </div>
        <div>
          <FormFieldSet
            value={mailIdFilled}
            onChange={setMailIdFilled}
            type="toMailIds"
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            value={mailIdDisabled}
            onChange={setMailIdDisabled}
            type="toMailIds"
            disabled={true}
          />
        </div>
        <div>
          <FormFieldSet
            value={mailIdFilledDisabled}
            onChange={setMailIdFilledDisabled}
            type="toMailIds"
            disabled={true}
            shadow={true}
          />
        </div>
      </div>

      <PropsTable
        data={MAILIDLIST_PROPS}
        title="toMailIds — Props Reference"
        typeLabel='type="toMailIds"'
        categories={CATEGORIES}
      />
      {/* userList shape callout */}
      <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4 text-xs text-blue-900">
        <p className="font-medium mb-1">userList item shape</p>
        <pre className="bg-blue-100 rounded p-2 text-xs leading-relaxed overflow-x-auto">{`userList={[
  { id: 1, name: "John Doe",    email: "john@example.com", avatar: "https://..." },
  { id: 2, name: "Jane Smith",  email: "jane@example.com" },
]}`}</pre>
        <p className="mt-2 text-blue-700">
          <code className="bg-blue-100 px-1 rounded">avatar</code> is optional —
          falls back to initials if not provided. Users whose email is already
          in <code className="bg-blue-100 px-1 rounded">value</code> are
          excluded from the suggestion dropdown automatically.
        </p>
      </div>

      {/* Chip behavior callout */}
      <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-4 text-xs text-amber-900">
        <p className="font-medium mb-1">How chips are created</p>
        <p className="leading-relaxed">
          Selecting a user from the suggestion dropdown adds their email as a
          chip. Typing a custom email and pressing{" "}
          <code className="bg-amber-100 px-1 rounded">Enter</code> validates the
          format and adds it as a chip. Pressing{" "}
          <code className="bg-amber-100 px-1 rounded">Backspace</code> when the
          input is empty removes the last chip. Duplicate emails and invalid
          formats are rejected automatically.
        </p>
      </div>
    </div>
  );
}

export default MailIdList;
